import type { CSSProperties, ReactNode } from "react";

export function Card({
  children,
  raised = false,
  style,
}: {
  children: ReactNode;
  raised?: boolean;
  style?: CSSProperties;
}) {
  return (
    <div
      style={{
        background: raised ? "var(--paper-raised)" : "var(--paper)",
        border: "1px solid var(--rule)",
        borderRadius: "var(--radius-lg)",
        padding: "var(--space-5)",
        color: "var(--ink)",
        font: "var(--type-body)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
